import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { useToast } from '@/components/ui/hooks/use-toast';
import { manualSyncFromEdlink } from '@/lib/api-calls';
import { EntityType } from '@airreading/common/data';
import { useMutation } from '@tanstack/react-query';
import { ReactNode, useState } from 'react';

interface ManualEdlinkSyncProps {
  entityType: EntityType;
  internalId: string;
  confirmationMessage?: ReactNode;
  trigger: ReactNode;
}

export const ManualEdlinkSync = ({ entityType, internalId, confirmationMessage, trigger }: ManualEdlinkSyncProps) => {
  confirmationMessage =
    confirmationMessage ??
    `This action will attemp to fetch the latest data from Edlink for ${entityType} with id ${internalId} and sync any updated data from Edlink into Air Reading.
    `;
  const [open, setOpen] = useState(false);
  const { mutateAsync, isPending } = useMutation({
    mutationFn: () => manualSyncFromEdlink(internalId, entityType),
  });
  const { toast } = useToast();
  const onSubmit = () => {
    return mutateAsync()
      .then(() => {
        toast({
          title: 'Sync successful',
        });

        // respone needs to return updated internal Ids to invalidate queries. TODO
        setOpen(false);
      })
      .catch((e: unknown) => {
        toast({
          title: 'Error syncing from Edlink',
          description: e instanceof Error ? e.message : undefined,
          variant: 'destructive',
        });
      });
  };

  return (
    <>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogTrigger>{trigger}</AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Sync from Edlink</AlertDialogTitle>
            <AlertDialogDescription>{confirmationMessage}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction>
              <Button
                loading={isPending}
                onClick={(e) => {
                  e.preventDefault();
                  onSubmit();
                }}
              >
                Sync
              </Button>
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
